/** Pure aggregation of the prologue dialogue (no registry, safe for Node unit tests). */
import type { DialogueData } from '@/core/types/contracts';
import { HARBOR_DIALOGUES } from './harbor';
import { STORM_DIALOGUES } from './storm';
import { ISLAND_DIALOGUES } from './island';
import { BLACK_WATER_DIALOGUES } from './blackWater';
import { FAREWELL_DIALOGUES } from './farewell';
import { ROAD_DIALOGUES } from './road';

export const PROLOGUE_DIALOGUES: DialogueData[] = [
  ...HARBOR_DIALOGUES,
  ...STORM_DIALOGUES,
  ...ISLAND_DIALOGUES,
  ...BLACK_WATER_DIALOGUES,
  ...FAREWELL_DIALOGUES,
  ...ROAD_DIALOGUES,
];

export function findPrologueDialogue(id: string): DialogueData | undefined {
  return PROLOGUE_DIALOGUES.find((d) => d.id === id);
}
